<template>
	<div class="molecular-modal">
		<button class="molecular-modal-btn" @click="modal = !modal">See Molecular Scale</button>
		<!-- TODO: Get Microscope Icon -->

		<transition name="modal" mode="out-in">
			<div class="modal-background" @click.self="modal = false" v-if="modal">
				<div class="modal-body">

					<p>For the sake of simplicity, anions and water molecules are not shown in this animation.</p>

					<div class="spheres">
						<template v-for="i in 8">
							<template v-for="j in 2">
								<div class="bigsphere" :class="[metalAbbr, (i === 4 && j === 2) ? 'mover' : '' ]" :style="`top:${i}em;left:${j}em`">
									<span>{{ metalAbbr }}</span>
								</div>
							</template>
						</template>

						<div class="smallsphere" style="top:1em;right:0em;"><span>H</span></div>
						<div class="smallsphere second" style="top:3em;right:0.1em;"><span>H</span></div>

						<div class="eee" style="top: 3.2em;"><span>e<sup>−</sup></span></div>
						<div class="eee" style="top: 3.6em;"><span>e<sup>−</sup></span></div>

					</div>

					<button class="modal-close btn" @click="modal=false">Dismiss</button>
				</div>
			</div>
		</transition>
	</div>
</template>


<script>
export default {
	name:"MolecularModalAcid",
	props:{
		metal: String
	},
	data() {
		return {
			modal: false
		}
	},
	methods: {
		getAbbr(metalFile){
			const metal = metalFile.replace('.png', '')
			switch (metal) {
				case 'copper':
					return 'Cu'
					break;
				case 'tin':
					return 'Sn'
					break
				case 'zinc':
					return 'Zn'
					break
				case 'silver':
					return 'Ag'
					break
				case 'nickel':
					return 'Ni'
					break
				case 'lead':
					return 'Pb'
					break
				case 'iron':
					return 'Fe'
					break
				case 'magnesium':
					return 'Mg'
					break;
			}
		}
	},
	beforeMount() {
		this.metalAbbr=this.getAbbr(this.metal)
	},	
}
</script>


<style lang="scss" scoped>
	.spheres {
		width: 10em;
		height: 10em;
		overflow: hidden;
		font-size: 3em;
		position: relative;
	}
	.bigsphere, .smallsphere {
		position: absolute;
		border-radius: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		span { font-size: 0.3em; color: #000; }	
	}
	.bigsphere {
		width: 1em;
		height: 1em;
		background: #ccc;

		&.mover{
			animation: moveBigBalls linear 10s;
			animation-iteration-count: infinite; //1;
			transform-origin: 50% 50%;
			animation-fill-mode: forwards;
			animation-timing-function: ease;
			&:after {
				position: absolute;
				top: -0.5em;
				right: -0.3em;
				content: '2+';
				font-size: 0.4em;
				color: #008;
				animation: moveBigBallsAfter linear 10s;
				animation-fill-mode: forwards;
				animation-timing-function: ease;
				animation-iteration-count: infinite; //1;
			}
		}
	}
	.smallsphere {
		width: 0.5em;
		height: 0.5em;
		border-radius: 100%;
		background: #ccf;
		span { font-size: 0.2em; color: #000; }	
		&:after {
			position: absolute;
			top: -0.5em;
			right: -0.3em;
			content: '+';
			font-size: 0.3em;
			color: #008;
			animation: moveSmallBallsAfter linear 10s;
			animation-fill-mode: forwards;
			animation-timing-function: ease;
			animation-iteration-count: infinite; //1;
		}
		animation: moveSmallBalls linear 10s;
		animation-iteration-count: infinite; //1;
		transform-origin: 50% 50%;
		animation-fill-mode: forwards;
		animation-timing-function: ease;
		&.second {
			animation: moveSmallBallSecond linear 10s;
			animation-iteration-count: infinite; //1;
			transform-origin: 50% 100%;
			animation-fill-mode: forwards;
			animation-timing-function: ease;			
		}
	}

	.Cu{
		background: linear-gradient(to right, darken(#C48226, 20%), #C48226, lighten(#C48226, 15%));
		span { color: #fff; }
	}

	.Zn{
		background: linear-gradient(to right, darken(#797979, 20%), #797979, lighten(#797979, 15%));
	}

	.Fe{
		background: linear-gradient(to right, darken(#9A9A9A, 20%), #9A9A9A, lighten(#9A9A9A, 15%));
		span { color: #fff; }
	}

	.Sn{
		background: linear-gradient(to right, darken(#CACACA, 20%), #CACACA, lighten(#CACACA, 15%));
	}

	.Pb{
		background: linear-gradient(to right, darken(#1D1D1D, 20%), #1D1D1D, lighten(#1D1D1D, 15%));
		span { color: #fff; }
	}

	.Ni{
		background: linear-gradient(to right, darken(#898B8D, 20%), #898B8D, lighten(#898B8D, 15%));
		span { color: #fff; }
	}

	.eee {
		position: absolute;
		left: 2.5em;
		opacity: 0;
		span { font-size: 0.3em; color: red; }	
		animation: moveEEE linear 10s;
		animation-iteration-count: infinite; //1;
		transform-origin: 50% 50%;
		animation-fill-mode: forwards;
		animation-timing-function: ease;
	}

	@keyframes moveSmallBalls{
		0% {
			transform: translate(0,0) rotate(0deg);
		}
		45% {
			transform: translate(-6.65em,2.75em) rotate(20deg);
			background: #ccf;

		}
		50% {
			background: #ccffd8;
		}

		55%{
			transform: translate(-6.65em,2.75em) rotate(20deg);
			background: #ccffd8;
		}

		60%{
			transform: translate(-6.65em,2.75em) rotate(20deg);
			background: #ccf;
		}

		100%{
			transform: translate(-6em,-7.3em) rotate(120deg);
		}
	}
	@keyframes moveSmallBallSecond{
		0% {
			transform: translate(0,0) rotate(0deg);
		}
		45% {
			transform: translate(-6.6em,1.25em) rotate(-10deg);
			background: #ccf;
		}
		50% {
			background: #ccffd8;
		}

		55%{
			transform: translate(-6.6em,1.25em) rotate(-10deg);
			background: #ccffd8;
		}

		60%{
			transform: translate(-6.6em,1.25em) rotate(-10deg);
			background: #ccf;
		}

		100%{
			transform: translate(-6em,-8.8em) rotate(120deg);
		}
	}

	@keyframes moveSmallBallsAfter {
		0% { opacity: 1; }
		45% { opacity: 1; }
		50% { opacity: 0; }
		100% { opacity: 0; }
	}

	@keyframes moveEEE{
		0%{
			opacity: 0;
			left: 2.5em;
		}

		25%{
			opacity: 0;
			left: 2.5em;
		}

		35%{
			opacity: 1;
			left: 2.5em;
		}

		55%{
			opacity: 1;
			left: 3em;
		}

		60%{
			opacity: 0;
			left: 3em;
		}


		100%{
			opacity: 0;
			left: 3em;
		}
	}

	@keyframes moveBigBalls{
		0%{
			transform: scale(1) translateX(0);
		}

		35%{
			transform: scale(1) translateX(0);
		}

		45%{
			transform: scale(.65) translateX(0em);
		}

		60%{
			transform: scale(.65) translateX(0em);
		}

		100%{
			transform: scale(.65) translateX(20em) rotate(270deg);
		}
	}

	@keyframes moveBigBallsAfter{
		0%{opacity: 0;}
		45%{opacity:0;}
		60%{opacity: 1;}
		100%{opacity: 1;}
	}

	.molecular-modal{

		.molecular-modal-btn{
			position: absolute;
			z-index: 5;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			border:1px solid $bordergrey;
			color: $grey;
			background: #fff;
			padding: .3em 1.4em;
			border-radius: 3em;
			font-size: 1em;
			font-weight: 400;
			white-space: nowrap;
			transition: all 250ms;

			&:hover{
				border-color: $blue;
				background: $blue;
				color: #fff;
			}
		}
	}

	.modal-background{
		background: rgba($green, 0.9);
		@supports(backdrop-filter: blur(10px)){
			background: rgba($green, 0.3);
			backdrop-filter: blur(10px);
		}
		position: fixed;
		top: 0px;
		left: 0%;
		width: 100%;
		height: 100%;
		z-index: 1000;
		padding: 1em;
		display: flex;
		justify-content: center;
		align-items: center;
		overflow-y: scroll;


		.modal-body{
			background: #fff;
			padding: 2em;
			border-radius: 1em;
			width: 90%;
			max-width: 680px;
			text-align: center;
			p { font-size: 0.7em; color: #aaa; }
		}
	}

	.modal-enter-active, .modal-leave-active {
		transition: all 500ms;

		.modal-body{
			transition: all 500ms;
		}
	}
	.modal-enter, .modal-leave-to {
		opacity: 0;

		.modal-body{
			transform: translateY(100px);
		}
	}
</style>